import { type EvaluationId } from '../model'
import { type WithOptionalScheme, withScheme } from './util'

export const toEvaluation = ({
  evaluationId,
  includeScheme = false,
}: WithOptionalScheme & { evaluationId: EvaluationId }): string => {
  return withScheme(`evaluation/${evaluationId}`, includeScheme)
}

export const toEvaluations = ({ includeScheme = false }: WithOptionalScheme): string => {
  return withScheme(`evaluation`, includeScheme)
}
